'use client';




interface DealCardProps {
  deal: {
    id: string;
    title: string;
    category: string;
    status: 'active' | 'monitoring' | 'closing';
    currentValue: string;
    targetROI: string;
    progress: number;
    image: string;
    alt: string;
    startDate: string;
    expectedCompletion: string;
    riskLevel: 'low' | 'medium' | 'high';
  };
  onClick: () => void;
}

const DealCard = ({ deal, onClick }: DealCardProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'monitoring':
        return 'bg-blue-100 text-blue-800';
      case 'closing':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getRiskColor = (risk: string) => {
    switch (risk) {
      case 'low':
        return 'text-green-600';
      case 'medium':
        return 'text-yellow-600';
      case 'high':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return null;
};

export default DealCard;